import { SSE_ERROR_EVENT } from '@mst-fe/shared';
import { EventSource } from 'eventsource';

import { showErrorNotification } from '../_shared/views/Notifications';
import { initEventSourceEndpoint } from './requests';

function initEventSource<T>(path: string, fn: (value: T) => void) {
  const es = initEventSourceEndpoint(path);

  es.onmessage = async (event) => {
    const response = typeof event.data === 'string' ? (JSON.parse(event.data) as T) : undefined;
    if (response) {
      fn(response);
    }
  };

  es.addEventListener(SSE_ERROR_EVENT, () => {
    console.error(`SSE stream for ${path} reported a server-side error`);
    showErrorNotification({
      message: 'Server Error',
      description: 'The server failed to load the latest data, so the information shown may be out of date.',
      deduplicationKey: `${SSE_ERROR_EVENT}:${path}`,
    });
  });

  return es;
}

/**
 * Creates an EventSource for the given URL path.
 * Calls the given callback when a new message from that endpoint is received.
 * Returns a function to stop the EventSource.
 */
export function observeEndpoint<T>(path: string, cb: (value: T) => void) {
  const es = initEventSource<T>(path, cb);

  return () => {
    if (es.readyState !== EventSource.CLOSED) {
      es.close();
    }
  };
}
